// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { registerMobileDeepLinkListener } from './mobile/deepLinks';
import { hydrateSessionFromNativeStorage } from './mobile/session';

const root = ReactDOM.createRoot(document.getElementById('root'));

function renderApp() {
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

async function bootstrap() {
  await hydrateSessionFromNativeStorage();
  await registerMobileDeepLinkListener();
  renderApp();
}

bootstrap().catch(() => {
  renderApp();
});
